import axios from "axios";
import { TTP_API_URL } from "../config";
import { getRequestConfig, throwCatchedError } from "../utils";

export const getIdentitiesVerificationStatus = (token) => {
  const requestUrl = `${TTP_API_URL}/mailing/registered-mails`;
  const params = {
    access_token: token,
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const registerEmail = (token, email) => {
  const requestUrl = `${TTP_API_URL}/mailing/verify-email`;
  const formData = new FormData();
  formData.append("access_token", token);
  formData.append("email", email);
  return axios.post(requestUrl, formData);
};
